import { Label as UiLabel } from '@/components/ui/label'
import { cn } from '@/lib/utils'

import { labelVariants } from '../../configs/label.config'

import type { ComponentProps } from 'react'

export function Label({ className, ...props }: ComponentProps<typeof UiLabel>) {
  return <UiLabel {...props} className={cn(labelVariants(), className)} />
}
